const sortBySelector = document.getElementById(
  'bank-review-hub-sort-by-selector'
)

const hubCardContainer = document.querySelector(
  '[data-js-selector=bank-review-hub-card-wrapper]'
)

const hubCards = Array.from(
  document.querySelectorAll('[data-js-selector=bank-review-hub-card]')
)

//bank review cards default sorted by overall rating
let currentSort = 'overall-rating'
const selectedElement = document.getElementsByClassName('--is-selected')
const sortButton = sortBySelector.querySelector('button')
const sortDropdownList = sortBySelector.querySelector('ul')

const sortDropdownListItems = Array.from(
  sortDropdownList.querySelectorAll('li')
)

//close dropdown if click is outside bounds of dropdown
window.addEventListener('click', e => {
  const isDropdownClick =
    e.target === sortBySelector || sortBySelector.contains(e.target)

  if (!isDropdownClick) {
    sortDropdownList.classList.remove('--is-active')
  }
})

//open dropdown
sortBySelector.addEventListener('click', () => {
  sortDropdownList.classList.toggle('--is-active')
})

//hides rating section
function hideAllStars() {
  const stars = Array.from(
    document.querySelectorAll(
      '[data-js-selector="bank-review-hub-card-star-rating"]'
    )
  )
  stars.forEach(function(item) {
    item.classList.add('+display-none')
  })
}

//shows rating section based on what is selected in the sort dropdown
function showStarsByRatingName(ratingName) {
  const starsToShow = Array.from(
    document.querySelectorAll(`[data-rating="${ratingName}"]`)
  )
  starsToShow.forEach(function(item) {
    item.classList.remove('+display-none')
  })
}

function sortCards(key) {
  hubCards.sort(function(a, b) {
    let aRating = parseFloat(a.getAttribute(`data-${key}`))
    let bRating = parseFloat(b.getAttribute(`data-${key}`))

    return bRating > aRating ? 1 : -1
  })
}

sortDropdownListItems.forEach(item => {
  item.addEventListener('click', event => {
    const { sortRatingItemLabel } = event.currentTarget.dataset
    const sortByKey = sortRatingItemLabel.toLowerCase().replace(/ /gi, '-') //replace all spaces with dashes

    if (currentSort === sortByKey) return
    currentSort = sortByKey

    //remove --is-selected class from previous sort and adding it to new selected sort
    selectedElement[0].classList.remove('--is-selected')
    item.classList.add('--is-selected')

    //changing the dropdown label to be equal to whatever sort is selected
    sortButton.innerHTML = item.querySelector('span').innerHTML

    sortCards(sortByKey)
    hideAllStars()
    showStarsByRatingName(sortByKey)

    for (let i = 0; i < hubCards.length; i++) {
      hubCardContainer.appendChild(hubCards[i])
    }
  })
})
